import { useTranslation } from '@/i18n';
import { TextLink } from '@moneyforward/ap-frontend-components';
import { FC } from 'react';

const AI_AGREEMENT_URL = 'https://biz.moneyforward.com/ai-agreement/';

export const AiAgreementLink: FC = () => {
  const { t } = useTranslation();

  return (
    <TextLink href={AI_AGREEMENT_URL} target='_blank'>
      {t('ai_service_setting.agreement_link')}
    </TextLink>
  );
};
